<template>
<!--答题卡-->
  <div id="examcard">
    <h2 class="title">
      <a @click="back()" class="prev"></a>
      <b>1</b>/20
    </h2>
    <h3 class="type">单选题 </h3>
    <div class="question-num">
      <router-link :to="{name: 'ExamTest', query: {exam_id: examId, chapter_id: chapterId, record_id: recordId, number: item.number}}" v-for="(item, index) in cardData" :key="index" :class="{ 'blue': item.is_right === 1, 'red': item.is_right === 0 }">{{item.number}}</router-link>
    </div>
    <!--
    <h3 class="type">单选题 <span>0/30</span></h3>
    <div class="question-num">
      <a href="" target="_blank" class="blue">1</a>
      <a href="" target="_blank">2</a>
      <a href="" target="_blank">3</a>
      <a href="" target="_blank">4</a>
      <a href="" target="_blank">5</a>
      <a href="" target="_blank">6</a>
      <a href="" target="_blank">7</a>
      <a href="" target="_blank">8</a>
      <a href="" target="_blank">9</a>
      <a href="" target="_blank">10</a>
      <a href="" target="_blank">11</a>
      <a href="" target="_blank">12</a>
      <a href="" target="_blank">13</a>
      <a href="" target="_blank">14</a>
      <a href="" target="_blank">15</a>
      <a href="" target="_blank">16</a>
      <a href="" target="_blank">17</a>
      <a href="" target="_blank">18</a>
    </div>
    <h3 class="type">多选题 <span>0/12</span></h3>
    <div class="question-num">
      <a href="" target="_blank" class="red">1</a>
      <a href="" target="_blank">2</a>
      <a href="" target="_blank">3</a>
      <a href="" target="_blank">4</a>
      <a href="" target="_blank">5</a>
      <a href="" target="_blank">6</a>
      <a href="" target="_blank">7</a>
      <a href="" target="_blank">8</a>
      <a href="" target="_blank">9</a>
      <a href="" target="_blank">10</a>
      <a href="" target="_blank">11</a>
      <a href="" target="_blank">12</a>
      <a href="" target="_blank">13</a>
      <a href="" target="_blank">14</a>
      <a href="" target="_blank">15</a>
      <a href="" target="_blank">16</a>
      <a href="" target="_blank">17</a>
      <a href="" target="_blank">18</a>
    </div>
    -->
    {{exam_id}}
    <div class="cue">
      <div><span class="blue"></span>正确</div>
      <div><span class="red"></span>错误</div>
      <div><span class="white"></span>未答</div>
    </div>
    <a @click="submitAnswer" class="fixed-bar">{{this.record_type === 2 ? '结束作答' : '保存下次继续'}}</a>
  </div>
</template>

<script>
export default {
  name: 'ExamCard',
  data () {
    return {
      examId: this.$route.query.exam_id,
      chapterId: this.$route.query.chapter_id,
      recordId: this.$route.query.record_id,
      recordType: this.$route.query.record_type,
      cardData: {},
      number: this.$route.query.number
    }
  },
  mounted () {
    this.getExamCard()
  },
  methods: {
    getExamCard () {
      let data = {
        exam_id: this.examId,
        chapter_id: this.chapterId,
        record_id: this.recordId
      }
      this.$axios({
        method: 'GET',
        url: '/api/app/v1/get_question_topic_list',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.cardData = res.data.data
          } else alert(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    submitAnswer () {
      let data = {
        record_id: this.recordId,
        record_type: this.recordType
      }
      this.$axios({
        method: 'POST',
        url: '/api/app/v1/post_question_test_paper',
        params: data,
        headers: {
          'sign': this.$encryption(data, this.$store.state.token, this.$store.state.uid)
        }
      })
        .then(res => {
          console.log(res)
          if (res.data.errcode === 200) {
            this.$router.push({name: 'ExamScore', query: {score: res.data.data.score}})
          } else console.log(res.data.message)
        })
        .catch(err => {
          console.log(err)
        })
    },
    back () {
      if (window.history.length <= 1) {
        this.$router.push({path: '/'})
      } else {
        this.$router.go(-1)
      }
    }
  }
}
</script>

<style scoped lang="stylus">
#examcard
  h2.title
    position: relative
    height: 1.08rem
    line-height: .8rem
    background-color: transparent
    padding: .14rem .16rem
    font-size: .32rem
    color: #A3A9B7
    font-weight: 600
    text-align: center
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    b
      font-size: .48rem
      color: #FF7052
    a.prev
      position: absolute
      top: .14rem
      left: .16rem
      display: block
      width: .8rem
      height: .8rem
      background-color: transparent
      -webkit-border-radius: 50%
      -moz-border-radius: 50%
      border-radius: 50%
      &::before
        content: ""
        position: absolute
        top: .3rem
        left: .32rem
        display: block
        width: .20rem
        height: .20rem
        border-left: .03rem solid #050505
        border-bottom: .03rem solid #050505
        -webkit-transform: rotate(45deg)
        -moz-transform: rotate(45deg)
        -ms-transform: rotate(45deg)
        -o-transform: rotate(45deg)
        transform: rotate(45deg)
  h3.type
    position: relative
    padding: 0 .4rem
    margin: .3rem 0
    font-size: .48rem
    color: #050505
    font-weight: 600
    -webkit-box-sizing: border-box
    -moz-box-sizing: border-box
    box-sizing: border-box
    span
      position: absolute
      top: .2rem
      right: .5rem
      font-size: .28rem
      color: #1E81F2
      font-weight: 400
  .question-num
    display: flex
    justify-content: left
    align-items: center
    align-content: space-around
    flex-wrap: wrap
    padding: 0 .31rem
    a
      display: block
      width: .8rem
      height: .8rem
      line-height: .8rem
      border: .02rem solid #D8D8D8
      margin: .1rem .17rem
      font-size: .36rem
      color: #333
      text-align: center
      -webkit-border-radius: .08rem
      -moz-border-radius: .08rem
      border-radius: .08rem
      -webkit-box-sizing: border-box
      -moz-box-sizing: border-box
      box-sizing: border-box
      &.blue
        background-color: #1E81F2
        border-color: #1E81F2
        color: #fff
      &.red
        background-color: #FF7052
        border-color: #FF7052
        color: #fff
  div.cue
    position: fixed
    bottom: 1.5rem
    left: 50%
    display: flex
    justify-content: space-between
    align-items: center
    width: 5.6rem
    height: .4rem
    line-height: .4rem
    color: #191919
    font-size: .28rem
    text-align: center
    -webkit-transform: translate(-50%, 0)
    -moz-transform: translate(-50%, 0)
    -ms-transform: translate(-50%, 0)
    -o-transform: translate(-50%, 0)
    transform: translate(-50%, 0)
    span
      position: relative
      top: -.02rem
      vertical-align: middle
      display: inline-block
      width: .28rem
      height: .28rem
      border: .02rem solid #D8D8D8
      margin-right: .1rem
      -webkit-border-radius: .04rem
      -moz-border-radius: .04rem
      border-radius: .04rem
      &.blue
        border-color: #1E81F2
        background-color: #1E81F2
      &.red
        border-color: #FF7052
        background-color: #FF7052
  a.fixed-bar
    position: fixed
    bottom: .4rem
    left: 50%
    display: block
    width: 6.54rem
    height: .8rem
    line-height: .8rem
    background-color: #FF7052
    color: #fff
    font-size: .36rem
    text-align: center
    -webkit-border-radius: .49rem
    -moz-border-radius: .49rem
    border-radius: .49rem
    -webkit-transform: translate(-50%, 0)
    -moz-transform: translate(-50%, 0)
    -ms-transform: translate(-50%, 0)
    -o-transform: translate(-50%, 0)
    transform: translate(-50%, 0)
</style>



// WEBPACK FOOTER //
// src/components/exam/ExamCard.vue